import { useState } from "react";
import { SketchPicker } from "react-color";
import WushPopover from "../layout/WushPopover";
import { Box, Stack } from "@mui/material";

export default function ColorPicker({ initialValue, onChangeComplete }) {
  const [ stateColor, setStateColor ] = useState(initialValue || "#000000");

  const handleChange = (color) => {
    setStateColor(color.hex);
  };

  const handleChangeComplete = (color) => {
    onChangeComplete(color.hex);
    setStateColor(color.hex);
  };

  return (
    <WushPopover 
      anchor={
        <Box
          sx={{
            height: '25px',
            width: '25px',
            borderRadius: '100px',
            backgroundColor: stateColor
          }}
        />
      }
    >
      <Stack p={2}>
        <SketchPicker 
          color={ stateColor }
          onChangeComplete={ handleChangeComplete }
          onChange={ handleChange}
        />
      </Stack>
    </WushPopover>
  );
}